// extracted by mini-css-extract-plugin
export default {"Gifs":"Gifs_Gifs__T8hWC"};